import React, { useState } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import * as Icon from "react-feather";

export default function JobListings() {
  const [jobModalOpen, setJobModalOpen] = useState(false);
  const [applyModalOpen, setApplyModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [applicationForm, setApplicationForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    resume: null,
    portfolioUrl: "",
  });

  const jobs = [
    // {
    //   id: 1,
    //   title: "Senior Data Engineer",
    //   duties: [
    //     "Design, Build & Optimize scalable, highly available data pipe/flow which can handle high data volumes",
    //     "Analyze, re-architect and re-platform on premise data warehouses to data platforms on cloud using AWS or 3rd party services",
    //     "Data Modelling expertise to address read/write performance and scalability",
    //     "Utilize AWS infrastructure to create completely serverless infrastructure that is easily scalable based on the usage",
    //     "Develop or direct software system testing or validation procedures, programming, or documentation",
    //     "Create common class libraries, forms and workflow and business components using Python, Informatica, SQL Server technologies",
    //     "Obtain and evaluate information on factors such as reporting formats required, costs, or information security needs to determine hardware configuration",
    //     "Modify existing software to correct errors, adapt it to new hardware, or upgrade interfaces and improve performance",
    //     "Write code in SQL programming language to create stored procedures, functions Views and Indexes",
    //     "Confer with data processing or project managers to obtain information on limitations or capabilities for data processing projects",
    //     "Store, retrieve, and manipulate data for analysis of system capabilities and requirements",
    //     "Confer with systems analysts, engineers, programmers and others to design systems and to obtain information on project limitations and capabilities, performance requirements and interfaces",
    //     "Determine database system performance standards",
    //     "Analyze information to determine, recommend, and plan installation of a new system or modification of an existing system",
    //     "Analyze user needs and software requirements to determine feasibility of design within time and cost constraints",
    //     "Coordinate functioning of inter-team dependencies and act as needed during software development phase",
    //     "Coordinate installation of software system",
    //   ],
    //   requirements: [
    //     "Bachelor's degree in Computer Science, Computer Engineering, Information Technology or closely related field",
    //     "Five years of employment experience in the position or related fields",
    //     "Experience with AWS cloud platforms and serverless architecture",
    //     "Proficiency in Python, SQL Server, and Informatica technologies",
    //     "Strong data modeling and database optimization skills",
    //     "Experience with data warehouse migration and cloud platform implementation",
    //   ],
    //   salary: "$135,803",
    //   hours: "Monday through Friday 8:00am to 4:00pm",
    //   jobLocation: "Shaker Heights, OH",
    //   contact: {
    //     email: "anand.sahai@numantratech.ai",
    //     // phone: "+1 (267) 776-4727",
    //     department: "Anand Sahai, Owner",
    //     address:
    //       "Numantra Technologies LLC, 20600 Chagrin Blvd #701, Shaker Heights, OH 44122",
    //   },
    //   description:
    //     "Join our team to design and optimize scalable data infrastructure using cutting-edge AWS technologies and serverless architecture. We're looking for a Senior Data Engineer who can build robust, scalable data pipelines and help migrate our on-premise data warehouses to cloud platforms.",
    // },
  ];

  const handleJobClick = (job) => {
    setSelectedJob(job);
    setJobModalOpen(true);
  };

  const handleApplyNow = () => {
    setJobModalOpen(false);
    setApplyModalOpen(true);
  };

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    setApplicationForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmitApplication = (e) => {
    e.preventDefault();
    // Here you would typically send the application data to your backend
    console.log("Application submitted:", {
      job: selectedJob.title,
      ...applicationForm,
    });

    // Reset form and close modal
    setApplicationForm({
      fullName: "",
      email: "",
      phone: "",
      resume: null,
      portfolioUrl: "",
    });
    setApplyModalOpen(false);
    setSelectedJob(null);

    // Show success message (you can implement a toast notification here)
    alert("Application submitted successfully!");
  };

  return (
    <>
      {/* Job Listings Start */}
      <section className="section" id="careers">
        <Container>
          <Row className="justify-content-center">
            <Col>
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-3">Join Our Team</h4>
                <p className="text-muted mx-auto para-desc mb-0">
                  Explore exciting career opportunities at Numantra Technologies
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {jobs.length === 0 ? (
              <>
                <p className="text-muted mx-auto para-desc mb-0 text-center">
                  Currently, there are no job openings available.
                </p>
                <p className="text-muted mx-auto para-desc mb-0 text-center">
                  Please check back later or contact us for more information.
                </p>
              </>
            ) : (
              jobs.map((job, index) => (
                <Col lg={6} md={12} className="col-12 mt-4 pt-2" key={index}>
                  <Card
                    className="border-0 job-card position-relative d-block overflow-hidden rounded shadow"
                    onClick={() => handleJobClick(job)}
                    style={{
                      cursor: "pointer",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-5px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <CardBody className="p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div className="flex-shrink-0">
                          <div className="avatar avatar-lg bg-primary rounded-circle d-flex align-items-center justify-content-center">
                            <Icon.Briefcase className="text-white" size={24} />
                          </div>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h5 className="mb-1">{job.title}</h5>
                          <p className="text-muted mb-0">
                            <Icon.MapPin className="fea icon-sm me-1" />
                            {job.jobLocation}
                          </p>
                        </div>
                      </div>

                      <p className="text-muted mb-3">{job.description}</p>

                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <span className="badge bg-success me-2">
                            <Icon.DollarSign className="fea icon-sm me-1" />
                            {job.salary}
                          </span>
                          <span className="badge bg-info">
                            <Icon.Clock className="fea icon-sm me-1" />
                            Full-time
                          </span>
                        </div>
                        <Button
                          color="primary"
                          size="sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleJobClick(job);
                          }}
                        >
                          View Details
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))
            )}
          </Row>
        </Container>
      </section>
      {/* Job Listings End */}

      {/* Job Details Modal */}
      <Modal
        isOpen={jobModalOpen}
        toggle={() => setJobModalOpen(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setJobModalOpen(false)}>
          {selectedJob?.title}
        </ModalHeader>
        <ModalBody>
          {selectedJob && (
            <div>
              <div className="mb-4">
                <h6 className="text-primary mb-2">Job Description</h6>
                <p>{selectedJob.description}</p>
              </div>

              <div className="mb-4">
                <h6 className="text-primary mb-2">
                  Key Duties & Responsibilities
                </h6>
                <ul className="list-unstyled">
                  {selectedJob.duties.map((duty, index) => (
                    <li key={index} className="mb-2">
                      <Icon.Check className="fea icon-sm text-success me-2" />
                      {duty}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mb-4">
                <h6 className="text-primary mb-2">Requirements</h6>
                <ul className="list-unstyled">
                  {selectedJob.requirements.map((req, index) => (
                    <li key={index} className="mb-2">
                      <Icon.Check className="fea icon-sm text-success me-2" />
                      {req}
                    </li>
                  ))}
                </ul>
              </div>

              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <h6 className="text-primary mb-1">Salary</h6>
                    <p className="mb-0">{selectedJob.salary}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <h6 className="text-primary mb-1">Work Hours</h6>
                    <p className="mb-0">{selectedJob.hours}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <h6 className="text-primary mb-1">Location</h6>
                    <p className="mb-0">{selectedJob.jobLocation}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <h6 className="text-primary mb-1">Contact</h6>
                    <p className="mb-0">{selectedJob.contact.department}</p>
                    <p className="mb-0">{selectedJob.contact.email}</p>
                    <p className="mb-0">{selectedJob.contact.phone}</p>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setJobModalOpen(false)}>
            Close
          </Button>
          <Button color="primary" onClick={handleApplyNow}>
            Apply Now
          </Button>
        </ModalFooter>
      </Modal>

      {/* Application Form Modal */}
      <Modal
        isOpen={applyModalOpen}
        toggle={() => setApplyModalOpen(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setApplyModalOpen(false)}>
          Apply for {selectedJob?.title}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmitApplication}>
            <FormGroup>
              <Label for="fullName">Full Name *</Label>
              <Input
                id="fullName"
                name="fullName"
                type="text"
                value={applicationForm.fullName}
                onChange={handleFormChange}
                required
              />
            </FormGroup>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="email">Email *</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    value={applicationForm.email}
                    onChange={handleFormChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="phone">Phone *</Label>
                  <Input
                    id="phone"
                    name="phone"
                    type="tel"
                    value={applicationForm.phone}
                    onChange={handleFormChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="resume">Resume (PDF) *</Label>
              <Input
                id="resume"
                name="resume"
                type="file"
                accept=".pdf"
                onChange={handleFormChange}
                required
              />
              <small className="text-muted">
                Please upload your resume in PDF format (Max 5MB)
              </small>
            </FormGroup>

            <FormGroup>
              <Label for="portfolioUrl">Portfolio URL</Label>
              <Input
                id="portfolioUrl"
                name="portfolioUrl"
                type="url"
                value={applicationForm.portfolioUrl}
                onChange={handleFormChange}
                placeholder="https://your-portfolio-website.com"
              />
              <small className="text-muted">
                Optional: Link to your portfolio, GitHub, or professional
                website
              </small>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setApplyModalOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSubmitApplication}>
            Submit Application
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
